(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/base/assets/javascripts/my-bets-route.js') >= 0) return;  svs.modules.push('/components/tipsen/base/assets/javascripts/my-bets-route.js');
"use strict";

const ProtectedRoute = svs.components.lbUtils.protectedRoute.ProtectedRoute;
const _ReactRouterDOM = ReactRouterDOM,
  Route = _ReactRouterDOM.Route,
  Switch = _ReactRouterDOM.Switch;
const tipsenLazy = svs.components.tipsen.tipsenLazy.tipsenLazy;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const _svs$components$tipse = svs.components.tipsen.modularBase,
  RouteWagerListFallback = _svs$components$tipse.RouteWagerListFallback,
  RouteWagerFallback = _svs$components$tipse.RouteWagerFallback;
const LazyWagerList = tipsenLazy('/cl/tipsen/route-wager-list', () => svs.components.tipsen.routeWagerList.PlayerWagersLists, {
  fallback: RouteWagerListFallback
});
const LazyWager = tipsenLazy('/cl/tipsen/route-wager', () => svs.components.tipsen.routeWager.RouteWager, {
  fallback: RouteWagerFallback
});
const roles = ['Player', 'CustomerService'];
const MyBetsRoute = () => React.createElement(ProtectedRoute, {
  roles: roles
}, React.createElement(Switch, null, React.createElement(Route, {
  component: LazyWager,
  path: "/".concat(TipsenModuleGameUrl.MY_BETS, "/:wagerId(\\d+)")
}), React.createElement(Route, {
  component: LazyWagerList
})));
setGlobal('svs.components.tipsen.base.MyBetsRoute', MyBetsRoute);

 })(window);